import { api as generatedApi, ProductsQuery } from '.codegen/generatedApi'
import { productSearchQueryVariablesParser } from 'app/selectors'
import { RootState } from 'app/store'
import { createSelector } from 'reselect'
import { ProductSearchArgs } from 'types'

/**
 * https://www.graphql-code-generator.com/plugins/typescript-rtk-query
 */
export const api = generatedApi
  .enhanceEndpoints({
    endpoints: {},
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      searchProducts: builder.query<ProductsQuery, ProductSearchArgs>(
        {
          query: (args) => {
            return {
              document: productSearchQueryVariablesParser(args), // Converts this to a string because of a bug with the taxArray query plugin
              variables: args // No, these aren't actually used - it's just so the query func has access to the args
            }
          }
        }
      )
      /* Add extra endpoints here */
    }),
  })


export const selectApi = (state: RootState) => state[api.reducerPath]

export const selectApiOnline = createSelector(selectApi, state => state)

export const { useSearchProductsQuery, useLazySearchProductsQuery } = api
export const useSearchProductsQuerySubscription = api.endpoints.searchProducts.useQuerySubscription

export * from '.codegen/generatedApi'
export default api
